import ArticleView from '../views/ArticleView.vue'

export const ARTICLES_PATH = 'articles'

export default [{
  path: ARTICLES_PATH,
  component: {
    template: '<router-view />'
  },
  children: [{
    name: 'articleView',
    path: ':slug',
    component: ArticleView
  }]
}]
